import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import ja from "./ja.json";

const resources = {
  en: {
    translation: en
  },
  ja: {
    translation: ja
  }
};

i18n
.use(LanguageDetector)
.use(initReactI18next)
.init({
  resources,
  detection: {
    order: ["navigator"]
  },
  fallbackLng: "en", 
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
